"use client"

import { Alert, AlertIcon, AlertTitle, AlertDescription, Box, Text } from "@chakra-ui/react"

import { useSupplierRetailer } from "../../wrappers/SupplierRetailerContext"
import { radius } from "../../theme/tokens"

/**
 * Shown in place of a report page when the SELECTED supplier's account is
 * suspended (non-payment, or the master's Restr toggle) and the viewer is not
 * a master admin (userid 1/2) — every other account type is blocked. Rendered
 * by AuthenticatedLayout for /sales, /insights, /strike, /ranging and /margin,
 * so the page itself never mounts and never fires a request the backend would
 * refuse (403 SUPPLIER_SUSPENDED — middleware/requireSupplierPaid).
 *
 * The supplier's OWN account sees the existing "Account payment required"
 * screen instead; this one is for everyone else looking at their data.
 */
const SupplierUnpaidNotice = ({ pageTitle }) => {
  const { selectedSupplier, selectedSupplierRow } = useSupplierRetailer()
  const name = (selectedSupplierRow && selectedSupplierRow.text) || selectedSupplier || "This supplier"

  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      py={10}
      borderRadius={radius.md}
      data-testid="supplier-unpaid-notice"
    >
      <AlertIcon boxSize="32px" mr={0} />
      <AlertTitle mt={3} mb={1} fontSize="lg">
        {name} account suspended
      </AlertTitle>
      <AlertDescription maxWidth="md">
        <Text>The {pageTitle || "report"} is unavailable while this account is suspended.</Text>
        <Box mt={2} fontSize="sm" opacity={0.85}>
          Select another supplier to continue.
        </Box>
      </AlertDescription>
    </Alert>
  )
}

export default SupplierUnpaidNotice
